import { render, staticRenderFns } from "./RankMode2.vue?vue&type=template&id=047742c6&scoped=true"
import script from "./RankMode2.vue?vue&type=script&lang=js"
export * from "./RankMode2.vue?vue&type=script&lang=js"
import style0 from "./RankMode2.vue?vue&type=style&index=0&id=047742c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047742c6",
  null
  
)

export default component.exports